export default __webpack_public_path__ + "../staticImages/sprite-sofortuberweisung-2x.png";